module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locales","languages":["pl","en"],"defaultLanguage":"pl","siteUrl":"http://localhost:8000","i18nextOptions":{"interpolation":{"escapeValue":false},"nsSeparator":false},"generateDefaultLanguagePage":false,"redirect":true},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
